import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function GruposPage({ empresa, usuario, onVoltar, onSair }) {
  const [grupos, setGrupos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({ id: null, nome: '', codigo: '', integracao: '', ativo: true, path_imagem: '', mobile: true });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });
  const [uploading, setUploading] = useState(false);

  const fetchGrupos = async () => {
    setLoading(true);
    setErro('');
    try {
      const res = await fetch(`${API_URL}/grupos?empresa_id=${empresa.id}`);
      const data = await res.json();
      setGrupos(data);
    } catch (err) {
      setErro('Erro ao buscar grupos');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchGrupos();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (grupo = null) => {
    if (grupo) {
      setForm({ ...grupo });
      setEditando(true);
    } else {
      setForm({ id: null, nome: '', codigo: '', integracao: '', ativo: true, path_imagem: '', mobile: true });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({ id: null, nome: '', codigo: '', integracao: '', ativo: true, path_imagem: '', mobile: true });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    if (name === 'nome' || name === 'codigo') {
      setForm(f => ({ ...f, [name]: value.toUpperCase() }));
    } else if (type === 'checkbox') {
      setForm(f => ({ ...f, [name]: checked }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.nome) {
      setErro('Preencha o campo Nome!');
      return;
    }
    if (uploading) {
      setErro('Aguarde o upload da imagem!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/grupos/${form.id}` : `${API_URL}/grupos`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          nome: form.nome,
          codigo: form.codigo,
          integracao: form.integracao,
          ativo: form.ativo,
          path_imagem: form.path_imagem,
          mobile: form.mobile
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar grupo');
      fecharModal();
      fetchGrupos();
    } catch (err) {
      setErro('Erro ao salvar grupo');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/grupos/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchGrupos();
    } catch {
      setErro('Erro ao remover grupo');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const gruposFiltrados = grupos.filter(g =>
    g.nome.toLowerCase().includes(pesquisa.toLowerCase()) ||
    (g.codigo || '').toLowerCase().includes(pesquisa.toLowerCase())
  );

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setErro('');
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empresa_id', empresa.id);
    try {
      const res = await fetch(`${API_URL}/upload-grupo-imagem`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('Erro ao fazer upload');
      const data = await res.json();
      const urlCompleta = "https://conexaopix.com.br/docs" + data.path;
      setForm(f => ({ ...f, path_imagem: urlCompleta }));
    } catch (err) {
      setErro('Erro ao fazer upload da imagem');
    }
    setUploading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Grupos</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por nome ou código..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {gruposFiltrados.map(g => (
              <div key={g.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                {g.path_imagem && (
                  <img src={g.path_imagem} alt={g.nome} className="w-16 h-16 object-cover rounded mx-auto mb-2 border shadow" />
                )}
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{g.nome}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(g)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(g.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Código:</b> {g.codigo}</div>
                <div className="text-gray-700 mb-1"><b>Integração:</b> {g.integracao || '-'}</div>
                <div className="text-gray-700 mb-1"><b>Ativo:</b> {g.ativo ? 'Sim' : 'Não'}</div>
                <div className="flex justify-between items-center text-gray-700 mb-1">
                  <span><b>Mobile:</b> {g.mobile ? 'Sim' : 'Não'}</span>
                  <span className="text-xs text-gray-500 font-bold">ID: {g.id}</span>
                </div>
              </div>
            ))}
            {gruposFiltrados.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhum grupo encontrado.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Grupo"
        >
          +
        </button>
        {/* Modal de inclusão/edição */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Grupo' : 'Novo Grupo'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nome*</label>
                  <input name="nome" value={form.nome} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={100} required />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Código</label>
                  <input name="codigo" value={form.codigo} onChange={handleChange} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" maxLength={20} readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Integração</label>
                  <input name="integracao" value={form.integracao} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={50} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Ativo</label>
                  <input name="ativo" type="checkbox" checked={form.ativo} onChange={handleChange} className="ml-2 align-middle" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Mobile</label>
                  <input name="mobile" type="checkbox" checked={form.mobile} onChange={handleChange} className="ml-2 align-middle" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Imagem (upload)</label>
                  <input type="file" accept="image/*" onChange={handleFileChange} className="border rounded px-3 py-2 w-full" />
                  {form.path_imagem && (
                    <div className="mt-2 flex items-center">
                      <img src={form.path_imagem} alt="Preview" className="w-16 h-16 object-cover rounded shadow border" />
                    </div>
                  )}
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" disabled={uploading} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{uploading ? 'Enviando imagem...' : editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm relative">
              <h4 className="text-lg font-bold mb-3">Remover Grupo</h4>
              <p className="mb-4">Deseja realmente remover este grupo?</p>
              <div className="d-flex justify-content-end gap-2 flex-row-reverse">
                <button onClick={confirmarRemocao} className="btn btn-danger px-4 py-2 rounded me-2 bg-red-600 text-white hover:bg-red-700 transition">Remover</button>
                <button onClick={cancelarRemocao} className="btn btn-secondary px-4 py-2 rounded bg-light text-dark border hover:bg-gray-200 transition">Cancelar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default GruposPage; 